export default "__VITE_ASSET__Cbj9RUGw__"